import { render, staticRenderFns } from "./splitPane.vue?vue&type=template&id=4d0127b6"
import script from "./splitPane.vue?vue&type=script&lang=js"
export * from "./splitPane.vue?vue&type=script&lang=js"
import style0 from "./splitPane.vue?vue&type=style&index=0&id=4d0127b6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports